import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem("token");
  //   config.headers["Authorization"] = "Bearer " + get_Token();
  config.headers["Authorization"] = "Bearer " + token;
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location = "/login";
    } else if (error.response?.status === 403) {
      toast.error("Permission Denied!");
    } else {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        const errorText = Object.values(error?.response?.data?.errors)?.[0];
        toast.error(errorText, {
          toastId: 'error-1',
      });
      }

      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
